module.exports = __webpack_public_path__ + "static/img/bg-02.ad6b9da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullwidth/bg-02.png
// module id = s/Bc
// module chunks = 1